import { StandardEvents } from '@shopify/events';

let refreshing = false;
let pending = false;

function renderCount(count) {
  const isZh = document.documentElement.lang.toLowerCase().startsWith('zh');
  document.querySelectorAll('[data-cgl-header-cart]').forEach((link) => {
    const badge = link.querySelector('[data-cgl-cart-count]');
    if (!badge) return;
    badge.textContent = String(count);
    badge.hidden = count === 0;
    link.setAttribute('aria-label', isZh ? `购物车，${count} 件商品` : `Cart, ${count} items`);
  });
}

async function refreshCount() {
  pending = true;
  if (refreshing) return;
  refreshing = true;
  try {
    // A mutation arriving during a read needs another read, not a stale count.
    while (pending) {
      pending = false;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, {
          cache: 'no-store', headers: { Accept: 'application/json' }
        });
        if (!response.ok) continue;
        const cart = await response.json();
        if (!pending && Number.isInteger(cart.item_count) && cart.item_count >= 0) {
          renderCount(cart.item_count);
        }
      } catch {
        // Keep the last confirmed count if the network is temporarily unavailable.
      }
    }
  } finally {
    refreshing = false;
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  // Standard events can fire before the cart mutation has finished.
  Promise.resolve(event.promise).then(refreshCount, refreshCount);
});
document.addEventListener('cart:refresh', refreshCount);
document.addEventListener('shopify:section:load', refreshCount);
window.addEventListener('pageshow', refreshCount);
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') refreshCount();
});
refreshCount();

window.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest('[data-cgl-header-cart]') : null;
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const drawer = document.getElementById('cart-drawer');
  if (!drawer || typeof drawer.open !== 'function') return;
  event.preventDefault();
  event.stopImmediatePropagation();
  try {
    drawer.open();
  } catch {
    window.location.assign(link.href);
  }
}, { capture: true });
